class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    const source = this.querySelector('[data-countdown-timer]');
    if (!source) return;

    const dateString = source.getAttribute('data-countdown-timer');
    this.date = dateString ? new Date(dateString).getTime() : NaN;
    if (Number.isNaN(this.date)) {
      this.style.display = 'none';
      return;
    }

    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) return;

    if (Date.now() > this.date) {
      this.style.display = 'none';
      return;
    }

    this.countdown();
    this.interval = setInterval(this.countdown.bind(this), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  countdown() {
    const currentDate = Date.now();
    const totalSeconds = (this.date - currentDate) / 1000;

    if (currentDate > this.date) {
      clearInterval(this.interval);
      this.style.display = 'none';
      return;
    }

    this.daysEl.innerHTML = this.formatTime(Math.floor(totalSeconds / 3600 / 24));
    this.hoursEl.innerHTML = this.formatTime(Math.floor(totalSeconds / 3600) % 24);
    this.minutesEl.innerHTML = this.formatTime(Math.floor(totalSeconds / 60) % 60);
    this.secondsEl.innerHTML = this.formatTime(Math.floor(totalSeconds) % 60);
  }

  formatTime(time) {
    return time < 10 ? `0${time}` : `${time}`;
  }
}

customElements.define('countdown-timer', CountdownTimer);
